import { withStyles } from '@mui/styles';
import { compose } from 'recompose';
import { styles } from './question.styles';
import Question from './question';
import Clinical_Question from './clinical_question';

export default compose(withStyles(styles))(Question);
export const ClinicalQuestion = compose(withStyles(styles))(Clinical_Question);
